<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Logo</th>
          <th>Site URL</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index">
          <td>
            <img :src="row.image" alt="Logo" class="personal-website-logo" />
          </td>
          <td>
            <div class="site-name">{{row.name}}</div>
            <div class="site-url" @click="copyLink(row.domain)">
              <span>{{ row.domain }}</span>
              <i
                class="fa fa-copy copy-icon"
                title="Copy URL"
              ></i>
            </div>
          </td>
          <td>
            <div class="actions">
              <a :href="row.domain" target="_blank" class="btn ">Visit</a>
              <a @click.prevent="openEmailModal(row.domain)" class="btn ">Email</a>
              <button  @click.prevent="downloadQR(row.domain, row.name)" class="btn qr-code-btn send-email"><i class="fas fa-qrcode"></i>QR Code</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <personalized-site-send-email-modal :selected-link="selectedLink"/>
     <!-- QR Modal -->
     <b-modal 
          id="QRModal" 
          centered
          hide-footer
          >
          <template #modal-header>
            <div class="view-clients-header">
              <b-button variant="close-btn" @click="closeModal">
                <i class="fas fa-times"></i>
              </b-button>
            </div>
          </template>
          <b-container fluid>
            <div class="view-clients-modal-content">
              <div class="repQR">
                <img :src="QRUrl" alt="">
                <h4>{{domainName}}</h4>
                <p>{{domainURL}}</p>
              </div>
              <div class="repInformation">
                <div>
                  <h3>{{ $store.getters.rep.name }}</h3>
                  <span class="repCode">{{ $store.getters.rep.code }}</span>
                </div>
                <div class="shareBtn" style="margin-right:-15%">
                   <button  @click="openEmailModal(domainURL)"><i class="fas fa-share-alt"></i> Share</button>
                </div>
                <div class="shareBtn">
                  <button @click.prevent="downloadFile()"><i class="fas fa-download"></i> Download</button>
                </div>
              </div>
              
            </div>
          </b-container>
        </b-modal> 
  </div>
</template>

<script>
import Api from "@/resource/Api";
import PersonalizedSiteSendEmailModal from "@/views/Dashboard/partials/PersonalizedSiteSendEmailModal";
export default {
    name: "PersonalizedSiteTable",
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    data :() => ({
        headers : [
            { key: 'logo', label: 'Logo' },
            { key: 'siteUrl', label: 'Site URL' },
            { key: 'visit', label: 'Visit' },
            { key: 'email', label: 'Send Email' },
            { key: 'copy', label: 'Copy Link' },
            { key: 'qrCode', label: 'QR Code' }
        ],
        QRUrl: '',
        domainName: '',
        selectedLink: '',
        domainURL: '',
        downloadApiUrl: process.env.VUE_APP_FILE_DOWNLOAD_PRESIGNED_URL
    }),
    components:{
      PersonalizedSiteSendEmailModal
    },
  methods: {
    copyLink(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$notify("Link Copied Successfully.");
        })
        .catch(() => {
          this.$notify("Failed to copy link.", "error");
        });
    },
        downloadQR(text, name) {
                const loader = this.$loading.show();
        Api.get("v2/qr-code/generate?qr_message="+text).then(res=>{
        this.QRUrl = res.data.data.url
        this.domainName = name
        this.domainURL = text
        this.$bvModal.show("QRModal")
        }).catch(err=>{
           console.error(err) 
        }).finally(() => {
           loader.hide(); 
        })
    },
    openEmailModal(link) {
      this.selectedLink = link
      this.$bvModal.show("personalizedSiteSendEmail");
        },
         downloadFile() {
      const downloadLink = `${this.downloadApiUrl}${encodeURIComponent(this.QRUrl)}`
      window.open(downloadLink, '_blank')
    },
    closeModal(){
      this.$bvModal.hide("QRModal");
    }
    },
};
</script>
<style src="@/assets/css/viewclients.css"></style>
<style scoped>
    th {
      background-color: #fafbfd;
    }
    td,
    th {
      padding: 1rem;
    }
    tbody, 
    td, 
    tfoot, 
    th, 
    thead, 
    tr {
      border-color: #d7e1ea;
      border-style: solid;
      border-width: 1px;
    }
    .personal-website-logo {
      min-height: 20px;
      max-height: 40px;
      object-fit: contain;
    }
    .site-name {
      font-weight: 500;
    }
    .site-url,
    .actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .actions {
      height: min-content;
      flex-wrap: wrap;
    }
    .actions .btn{
      min-width: max-content;
      flex-grow: 1;
    }
    .copy-icon {
      cursor: pointer;
      color: #007bff;
    }
    .qr-code-btn i {
      margin-right: 0.5rem;
    }
    .actions a {
      border: none;
      border-radius: 6px;
      margin-right: .5rem;
      /* padding: 8px 1.5rem; */
      
      font-weight: 600;
      color: #fff !important;
      background: transparent linear-gradient(180deg,#0cf,#1597b8 49%,#0567bc) 0 0 no-repeat padding-box;
      box-shadow: 0 3px 6px rgba(0,0,0,.1607843137254902) !important;
    }
    .actions button{
      background: #fff !important;
      border-radius: 6px !important;
      color: #333 !important;
      border: 1px solid #333 !important;
      
      padding: 7px 12px !important;
      margin-right: 10px;
      
      font-size: 14px !important;
      transition: all .4s ease;
    }
</style>